import { type CanvasElementDefinition } from '../../canvas-elements/element-definition';

import { getIoConfig } from './_base-chart.element';
import { getDefaults, getInitial, getPropsConfig } from './_base-round-chart.element';
import { DoughnutChartElementHandler } from './ai/doughnut-chart.element-handler';
import { DoughnutChartDefinitionMapper } from './ai/round-chart.definition-mapper';
import { ChartComponent } from './chart.component';
import { CHART_DIMENSIONS } from './chart.models';
import { ChartPropsBuilder } from './chart.props-builder';
import { ChartPropsExtractor } from './chart.props-extractor';
import { chartV2Migration } from './migrations/002-all-chart-types.migration';
import { chartV3Migration } from './migrations/003-chart.migration';

export function getDoughnutChartDefinition(): CanvasElementDefinition<'chartDoughnut'> {
  return {
    type: 'chartDoughnut',
    componentType: ChartComponent<'chartDoughnut'>,
    isListed: true,
    name: 'Donut Chart',
    width: { mode: 'value', value: CHART_DIMENSIONS.width, fixed: true },
    height: { mode: 'value', value: CHART_DIMENSIONS.height, fixed: true },
    ioConfig: getIoConfig(),
    propsConfig: getPropsConfig('chartDoughnut'),
    propsBuilder: ChartPropsBuilder,
    propsExtractor: ChartPropsExtractor,
    defaults: getDefaults('Donut Chart', 'chartDoughnut'),
    initial: getInitial(),
    groups: ['charts'],
    styleIncludePaths: [
      'style',
      'content.font.fontFamily',
      'content.font.style',
      'content.font.fontSize',
      'content.title.iconPosition',
    ],
    features: {
      ai: {
        showAiPromptAutomatically: true,
        description: true,
      },
      visualStyle: 'block',
    },
    ai: {
      name: 'chartDoughnut',
      handler: () => DoughnutChartElementHandler,
      definitionMapper: () => DoughnutChartDefinitionMapper,
    },

    version: 3,
    migrations: {
      2: chartV2Migration,
      3: chartV3Migration,
    },
  };
}
